/**
 * Venttra - FireCMS CMSApp configuration
 * Collections and CMS setup.
 */
import { destinationsCollection, nestedDivisionsCollection, primaryDivisionsCollection } from "./collections/destinations";
import { adminDivisionTypesCollection } from "./collections/adminDivisionTypes";
import { guidesCollection } from "./collections/guides";
import { articlesCollection } from "./collections/articles";
import { authorsCollection } from "./collections/authors";
import { siteChromeCollection } from "./collections/siteChrome";
import { pageCopyCollection } from "./collections/pageCopy";
import { communityStoriesCollection } from "./collections/communityStories";
import { hotelsCollection } from "./collections/hotels";
import { homeHeroSetsCollection } from "./collections/homeHeroSets";
import { publishLogsCollection } from "./collections/publishLogs";

export const cmsCollections = [
  destinationsCollection,
  primaryDivisionsCollection,
  nestedDivisionsCollection,
  adminDivisionTypesCollection,
  guidesCollection,
  articlesCollection,
  authorsCollection,
  siteChromeCollection,
  pageCopyCollection,
  communityStoriesCollection,
  hotelsCollection,
  homeHeroSetsCollection,
  publishLogsCollection,
];
